var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"caption mt-2 mb-0 grey--text"},[_vm._v("\n  * indicates required field\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }